import { render, staticRenderFns } from "./sendMailToCustomerModal.vue?vue&type=template&id=073042da&scoped=true&"
import script from "./sendMailToCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./sendMailToCustomerModal.vue?vue&type=script&lang=ts&"
import style0 from "./sendMailToCustomerModal.vue?vue&type=style&index=0&id=073042da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073042da",
  null
  
)

export default component.exports